import { render, staticRenderFns } from "./dinogems.vue?vue&type=template&id=2c3cfbec"
import script from "./dinogems.vue?vue&type=script&lang=js"
export * from "./dinogems.vue?vue&type=script&lang=js"
import style0 from "./dinogems.vue?vue&type=style&index=0&id=2c3cfbec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports